import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterElements",
    standalone: false
})
export class FilterElementsPipe implements PipeTransform {
	transform(array: any[], filteredArray: any[], refresh: number = 1, id: string = "id"): any {
		if (!filteredArray) return array;
		return array.filter((el) => filteredArray.some((x) => x[id] == el[id])
		);
	}
}